<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
<div class="search-upload-continer">
  <div class="search">
    <p-fieldset legend="Search" class="search-fieldSet">
      <div>
        <div class="ui-inputgroup">
          <button pButton class="theme-button noHover btn-barcode labelButton mr-4 mb-4" type="button"
            label="Barcode"></button>
          <input [(ngModel)]="barCode" style="width:15.625rem;height:2.125rem; margin-bottom: 1.4rem;" placeholder=" ">
        </div>
      </div>
      <div class="date-input-continer">
        <div class="from-input">
          <div class="ui-inputgroup">
            <button pButton class="theme-button noHover labelButton mr-2" style="width: 10rem;height: 2.5rem;" type="button"
              label="From Date"></button>
            <p-calendar [(ngModel)]="fromDate" size="10" dateFormat="dd.mm.yy" [showIcon]="true"></p-calendar>
          </div>
        </div>
        <div class="to-input">
          <div class="ui-inputgroup">
            <button pButton class="theme-button noHover labelButton mr-2" style="width: 10rem;height: 2.5rem;" type="button"
              label="To Date"></button>
            <p-calendar [(ngModel)]="toDate" size="10" dateFormat="dd.mm.yy" [showIcon]="true">
            </p-calendar>
          </div>
        </div>
      </div>
      <div class="search-fieldSet">
        <div class="ui-inputgroup">
          <div class="col-12 flex p-0 m-4">
            <div class="col-3 p-0">
              <button pButton label="Clear" (click)="clearSearch()" class="buttonsRound otherbutton"></button>
            </div>
            <div class="col-3 p-0">
              <button pButton label="Export" (click)="exportAnnounced()" class="buttonsRound endButton"></button>
            </div>
            <div class="col-3 p-0">
              <button pButton label="Search" (click)="searchAnnounceList(0, 10)" class="buttonsRound startButton"></button>
            </div>
          </div>
        </div>
      </div>
    </p-fieldset>
  </div>
  <div class="upload">
    <p-fieldset legend="Upload">
      <div class="col-12 flex parent mt-2">
        <div class="col-10 child">
          <input #csvmanual pInputText style="width: 100%; height: 2.5rem;" class="form-control mb-4" name="profile" type="file"
            accept=".xlsx" (change)="onFileSelect($event)" id="fileChooser" placeholder="Upload File"
            #fileInput />
        </div>
        <div class="col-2 child">
          <button pButton icon="fa fa-upload" type="submit" id="uploadButtonExcel"
            (click)="manualAnnouncement()" [disabled]="isFileNotSelected" class="buttonsRound clear-btn mt-0"
            style="margin-bottom: 1%;width: 40px; height: 2.3rem;">
          </button>
        </div>
      </div>

      <div class="col-12 flex p-0">
      <div class="col-6 parent mt-1 upload-match">
        <div class="ui-inputgroup">
          <button pButton class="theme-button noHover labelButton" style="width:9rem;height:38px;" type="button" label="Project"></button>
          <p-dropdown placeholder="Project" class="senderDropDown"
            [options]="projectList" filter="true" name="projectList" [(ngModel)]="project"
            (onChange)="getSelectedProjectSampleType()">
          </p-dropdown>
        </div>
      </div> 

      <div class="col-6 parent mt-1 upload-match"  *ngIf="!workFlow?.sampleTypeInFile">
        <div class="ui-inputgroup">
          <button pButton style="height: 38px;" class="theme-button noHover labelButton" type="button" label="Sample Type"></button>
          <p-dropdown placeholder="Sample Type" class="senderDropDown"
          [options]="sampleTypeList" filter="true" name="sampleTypeList" [(ngModel)]="selectedProcessFlow">
        </p-dropdown>
        </div>
      </div> 
    </div>
    </p-fieldset>
  </div>
</div>
<!-- Table Starts -->
<div class="table-margine-top">
    <p-table id="table-data" [columns]="cols" [value]="deliveryLists" selectionMode="single" [loading]="loading"
    selectionMode="single" [totalRecords]="totalRecords"
    (onRowSelect)="onRowSelect($event)" [paginator]="true" [rows]="10" [lazy]="true" (onLazyLoad)="loadLazy($event)">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'width': col.width}">
          {{col.header}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-deliveryLists let-columns="columns">
      <tr [pSelectableRow]="deliveryLists">
        <ng-container *ngFor="let col of columns">
          <td *ngIf="col.field!=isBoxLink && col.field!='excel'">
            {{ col.date ? (deliveryLists[col.field]| date : col.format) : deliveryLists[col.field] }}
          </td>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          No records found
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<!-- Table Ended -->

<p-dialog [header]="getHeader()" [(visible)]="deliveryIDSelected" showEffect="fade" position="top"
  [modal]="true"  [contentStyle]="{'max-height':'70vh', 'width':'850px'}">
  <div class="content-in-multi-update-popup">
    <table id="scanTable" aria-describedby="View samples" class="table">
      <tbody>
        <tr>
          <th>Sample ID</th>
          <th>Plate ID</th>
          <th>Creation Date</th>
          <th>Project ID</th>
        </tr>
        <tr *ngFor="let sample of sampleList; let i=index">
          <td>{{sample.barCode}}</td>
          <td>{{sample.plateID}}</td>
          <td>{{sample.creationDate | date: 'dd.MM.yy HH:mm'}}</td>
          <td>{{sample.projectID}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</p-dialog>


<p-dialog header="Error(s)" [(visible)]="duplicateValues" [style]="{width:'750px'}" showEffect="fade" position="top"
  [modal]="true" [contentStyle]="{'max-height':'70vh'}" (onHide)="resetValues()">
  <div class="content-in-multi-update-popup">
    {{errorMessage}}
  </div>
  <div class="content-in-multi-update-popup margin-bottom">
    Plate(s) not uploaded. Please try again.
  </div>
  <div class="ui-g-12 p-0">
    <div class="ui-g-5 padding-left">
      <table *ngIf="dupSamples" id="scanTable" aria-describedby="View samples duplicates" class="table">
        <tr>
          <th>Duplicate Samples</th>
        </tr>
        <tr *ngFor="let sample of dupSamplesList; let i=index">
          <td>{{sample}}</td>
        </tr>
      </table>
    </div>
    <div class="ui-g-5">
      <table *ngIf="dupPlates" id="scanTable" aria-describedby="View plates duplicates" class="table">
        <tr>
          <th>Duplicate Plates</th>
        </tr>
        <tr *ngFor="let plate of dupPlatesList; let i=index">
          <td>{{plate}}</td>
        </tr>
      </table>
    </div>
  </div>
</p-dialog>